import { useLazyQuery } from '@apollo/client'
import { AllUsers, AllUsersLazy, AllUsersVariables, AllUsersLazyVariables } from '../../types'
import { ALL_USERS, ALL_USERS_LAZY } from './operations'

const useUsers = () => {
  const [getUsers, users] = useLazyQuery<AllUsers, AllUsersVariables>(ALL_USERS)

  return {
    getUsers,
    users,
  }
}

const useLazyUsers = ({ onCompleted }: { onCompleted: (data: AllUsers) => void }) =>
  useLazyQuery<AllUsersLazy, AllUsersLazyVariables>(ALL_USERS_LAZY, {
    onCompleted,
  })

export { useUsers, useLazyUsers }
